module.exports = __webpack_public_path__ + "static/media/illuminate-thumbnail1.26856954.png";